import Vue from 'vue'
import Router from 'vue-router'
import homeRouter from './home'
import store from '../store/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: () => {
        if(store.state.user){
          return '/home'
        } else  {
          return '/home'
         //return '/login'
        }
      }
    },
    {
      path: '/login', // 登录
      component: () => import('../views/login/login'),
      meta: {
        title: '管理登录',
        needLogin: false // 是否需要登录才能访问
      }
    },
    {
      path: '/home',
      component: () => import('../views/home/home'),
      children: homeRouter,
    }
  ]
})


// 设立导航守卫
router.beforeEach((to, from, next) => {

  // 因为导航守卫会比 created 更早触发，所以要先获取本地数据
  // 获取本地用户数据,当用户手动退出时，清空本地数据
  let user = JSON.parse(window.sessionStorage.getItem('user'))
    // 验证是否登录
  if (user === null  && to.meta.needLogin ) {
    // 如果他曾经登录过机构端  sessionStorage ...
    // 如果用户没有登录，并且跳往的页面需要登录才能进入时，让他跳往登录页
    next({
      path: '/login'
    })
  }
  // 如果上述条件都不符合，让其正常跳转
  next()
})

export default router